export default "__VITE_ASSET__647448fc__"